


























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import {
	checkboxCircleIcon,
	errorWarningIcon,
} from '../mixins/style/icon-mixins';

@Component({})
export default class SnackBar extends Vue {
	@Prop()
	text: string | string[] | undefined;

	@Prop({ type: String })
	type: 'success' | 'error' | 'networkError' | 'warning' | undefined;

	get isMultiLine() {
		if (!this.text) {
			return false;
		}
		return typeof this.text !== 'string' && this.text.length > 1;
	}

	content = '';
	timeout = '10000';
	visible = false;
	isTypeError = false;
	isTypeWarning = false;

	get backgroundColor() {
		return this.isTypeError
			? 'snackbarErrorBackground'
			: this.isTypeWarning
			? 'snackbarWarningBackground'
			: 'snackbarSuccessBackground';
	}

	get contentClass() {
		return this.isTypeError
			? 'error--text'
			: this.isTypeWarning
			? 'warning--text'
			: 'primary--text text--darken-1';
	}

	get color() {
		return this.isTypeError
			? 'error'
			: this.isTypeWarning
			? 'warning'
			: 'primary darken-1';
	}

	get icon() {
		return this.isTypeError || this.isTypeWarning
			? errorWarningIcon
			: checkboxCircleIcon;
	}

	@Watch('text')
	onTextChanged(value: string) {
		if (value) {
			this.content = value;
		}
		this.visible = !!value;
	}

	@Watch('type')
	onTypeChanged(value: string) {
		if (value) {
			this.isTypeError = ['error', 'networkError'].includes(value);
			this.isTypeWarning = ['warning'].includes(value);
		}
	}

	onClose() {
		this.$emit('closed');
	}

	onVisibleChanged(visible: any) {
		if (!visible) {
			this.$emit('closed');
		}
	}
}
